<template>
<div class="chapter">
<div class="inner_page">
<div class="fm-title"><span class="small">CONTENTS</span></div>
<div class="toc1"><a href="#/preface#toc1a" id="toc1">Preface: Maize for the Metate</a></div>
<div class="toc2"><a href="#/ch01#toc2a" id="toc2">Phantoms in the Mirror</a></div>
<div class="toc2"><a href="#/ch02#toc3a" id="toc3">The “Good Old Mission Days” Never Existed</a></div>
<div class="toc2"><span href="#/ch03#toc4a" id="toc4" title="Link target outside of Sample">Josefa of Downieville: The Obscure Life and Notable Death of a Chicana in Gold Rush California</span></div>
<div class="toc2"><span href="#/ch04#toc5a" id="toc5" title="Link target outside of Sample">Triptych: Memories of the San Fernando Valley</span></div>
<div class="toc2"><span href="#/ch05#toc6a" id="toc6" title="Link target outside of Sample">Gathering Thunder</span></div>
<div class="toc2"><span href="#/ch06#toc7a" id="toc7" title="Link target outside of Sample"><i>Tropi(lo)calidad:</i> Macondo in La Mission</span></div>
<div class="toc2"><span href="#/ch07#toc8a" id="toc8" title="Link target outside of Sample">Petroglyph of Memory</span></div>
<div class="toc2"><span href="#/ch08#toc9a" id="toc9" title="Link target outside of Sample">The Marin Headlands: A Meditation on Place</span></div>
<div class="toc2"><span href="#/ch09#toc10a" id="toc10" title="Link target outside of Sample">The Homecoming of an Azteca-Mexica Clan</span></div>
<div class="toc3"><span href="#/notes#toc11a" id="toc11" title="Link target outside of Sample">Notes</span></div>
<div class="toc2"><span href="#/bibliography#toc12a" id="toc12" title="Link target outside of Sample">Selected Bibliography</span></div>
<div class="toc2"><span href="#/ack#toc13a" id="toc13" title="Link target outside of Sample">Acknowledgments</span></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?7bd92c56